import { collection, QueryDocumentSnapshot } from "firebase/firestore";
import { db } from "~/integrations/firebase/firestore";
import { OnixChunkReporting } from "reedy-data/models";

export interface OnixChunkReportingWithId extends OnixChunkReporting {
  id: string;
}

type OnixChunkReportingFromFirebase = OnixChunkReporting;

const onixChunkReportingConverter = {
  toFirestore: (record: OnixChunkReporting) => record,
  fromFirestore(
    snapshot: QueryDocumentSnapshot<OnixChunkReportingFromFirebase>,
  ): OnixChunkReportingWithId {
    const data = snapshot.data();

    return {
      ...data,
      id: snapshot.id,
    };
  },
};

export const getOnixChunkReportingCollection = () =>
  collection(db, "onixChunkReporting").withConverter(
    onixChunkReportingConverter,
  );
